module.exports = __webpack_public_path__ + "ed716f38004788025cd8638add724e2e.jpg";